import axios from "../utiles/axios.util";
import { push } from "svelte-spa-router";

export async function get(url) {
    try {
        let response;

        response = await axios.get(url);

        if (response.status === 200) {
            if (response.data.code === 200) {
                return response.data;
            } else {
                return null;
            }
        } else {
            alert(
                "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다.",
            );
        }
    } catch (e) {
        // [디버그 로그] 로직과 무관, 에러 확인용 콘솔 출력 - 필요시 이 라인만 찾아 수정/제거
        console.log(e);
    }

    return axios.get(url);
}

export async function postJson(url, body) {
    try {
        const response = await axios.post(url, body, {
            headers: { "Content-Type": "application/json" },
        });

        if (response.status === 200) {
            if (response.data.code === 200) {
                return response.data;
            } else {
                alert(response.data.msg || "처리 중 오류가 발생했습니다.");
                return null;
            }
        } else {
            alert(
                "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다.",
            );
            return null;
        }
    } catch (e) {
        // [디버그 로그] 로직과 무관, 에러 확인용 콘솔 출력 - 필요시 이 라인만 찾아 수정/제거
        console.log(e);
        return null;
    }
}

export async function post(url, formData) {
    try {
        let response;

        response = await axios.post(url, formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });

        if (response.status === 200) {
            if (response.data.code === 200) {
                return response.data;
            } else {
                alert(response.data.msg);
                return null;
            }
        } else {
            alert(
                "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다.",
            );
        }
    } catch (e) {
        // [디버그 로그] 로직과 무관, 에러 확인용 콘솔 출력 - 필요시 이 라인만 찾아 수정/제거
        console.log(e);
    }
}
